const isProd = typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production';

export default {
  server: 'https://admin.lalaenglish.com.ua/index.php/',
  server_img: 'https://admin.lalaenglish.com.ua/',
  google_key: 'AIzaSyA1e-85hAFjfVtFPOw7AVh1BF7d6IwDmFA',
  // Enable API logging only when not in production builds
  apiLog: !isProd,
};